import {
	faCheck,
	faChevronDown,
	faChevronLeft,
	faDownload,
	faMapMarker,
	faMapMarkerAlt,
	faMinus,
	faPlus,
	faTimes,
	faInfoCircle,
  faLayerGroup,
} from '@fortawesome/free-solid-svg-icons';

import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

export const icons = [
	// solid
	faChevronDown,
	faChevronLeft,
	faCheck,
	faPlus,
	faMinus,
	faMapMarker,
	faMapMarkerAlt,
	faDownload,
	faTimes,
	faInfoCircle,
  faLayerGroup,

	// regular
	faEnvelope,
];
